// 部门推出申请
import axios from '../axios';

/**
 * 通过会员退会申请
 * @param data
 * @returns {*|Promise|Promise<any>}
 */
export const approvalDeptRemoveApply = data => {
  return axios({
    url: 'mDeptRemoveApply/approvalDeptRemoveApply ',
    method: 'post',
    data,
  });
};

/**
 * 驳回会员退会申请
 * @param data
 * @returns {*|Promise|Promise<any>}
 */
export const rejectDeptRemoveApply = data => {
  return axios({
    url: 'mDeptRemoveApply/rejectDeptRemoveApply',
    method: 'post',
    data,
  });
};

/**
 * 驳回会员退会申请
 * @param data
 * @returns {*|Promise|Promise<any>}
 */
export const getDeptRemoveApplyByDeptId = data => {
  return axios({
    url: 'mDeptRemoveApply/getDeptRemoveApplyByDeptId',
    method: 'post',
    data,
  });
};

/**
 * 创建退会申请
 * @param data
 * @returns {*|Promise|Promise<any>}
 */
export const createDeptRemoveApply = (data, params) => {
  return axios({
    url: 'mDeptRemoveApply/createDeptRemoveApply',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data,
    params: params,
  });
};

/**
 * 获取会员退会申请已审核列表
 * @param data
 * @returns {*|Promise|Promise<any>}
 */
export const getDeptRemoveApplyListOfApproved = data => {
  return axios({
    url: 'mDeptRemoveApply/getDeptRemoveApplyListOfApproved  ',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data,
  });
};
/**
 * 根据条件查询
 * @param data
 * @returns {*|Promise|Promise<unknown>}
 */
export const getDeptExtendListByCondition = data => {
  return axios({
    url: 'mDeptRemoveApply/getDeptExtendListByCondition',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data,
  });
};
/**
 * 获取会员退会申请待审核列表
 * @param data
 * @returns {*|Promise|Promise<any>}
 */
export const getDeptRemoveApplyListOfUnApproval = data => {
  return axios({
    url: 'mDeptRemoveApply/getDeptRemoveApplyListOfUnApproval   ',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data,
  });
};

/**
 * 获取所有会员退会申请列表
 * @param data
 * @returns {*|Promise|Promise<any>}
 */
export const getDeptRemoveApplyListOfAllApproved = data => {
  return axios({
    url: 'mDeptRemoveApply/getDeptRemoveApplyListOfAllApproved   ',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data,
  });
};



// WEBPACK FOOTER //
// ./src/http/moudules/deptRemoveApply.js